/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { ROCKET_POOL_ERC20 } from '../constants';
export var GetEthValue = createPlugin({
    protocol: 'ROCKETPOOL',
    type: 'GETTER',
    method: 'getEthValue',
    supportedContracts: ROCKET_POOL_ERC20,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                rethAmount: new FctValue18({}),
            },
        },
        output: {
            ethAmount: new FctValue18({}),
        },
    }); },
});
